import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { GroupDto } from "./GroupDto";

export class GetGroupsContainingUserResultDto extends DtoBase {

	public Groups: List<GroupDto>;

	constructor() {
		super();

		this.Groups = new List<GroupDto>();
	}

	public get HasGroups(): boolean {
		return (!!this.Groups && this.Groups.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.get_groups_containing_user_result = {};
		obj = obj.get_groups_containing_user_result;

		super.Write(obj, context);

		if (this.HasGroups) {
			obj.groups = [];
			ObjSerUtils.WriteObjSerCollection(obj.groups, this.Groups, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.get_groups_containing_user_result)
			throw new Error();
		obj = obj.get_groups_containing_user_result;

		super.Read(obj, context);

		if (obj.groups !== undefined) {
			this.Groups = new List<GroupDto>();
			ObjSerUtils.ReadObjSerCollection(obj.groups, this.Groups,
				(value: any) => new GroupDto(), context);
		}
	}

}
